//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { TelephoneInformationUpdateItem } from './TelephoneInformationUpdateItem';
import { IEmailUpdate } from './IEmailUpdate';
import { StudentStatus } from './Enums';

export class StudentUpdateItem extends ItemBase implements IEmailUpdate {
    AdultStudentParentID?: string | null;
    DateOfBirth?: string | null;
    DateStarted?: string | null;
    EmailAddress?: string | null;
    FaceTimeID?: string | null;
    FirstName?: string | null;
    Gender?: string | null;
    LastName?: string | null;
    LocalSchool?: string | null;
    Note?: string | null;
    Referrer?: string | null;
    SendEmailReminders?: boolean;
    SendSMSReminders?: boolean;
    SkillLevel?: string | null;
    SkypeUsername?: string | null;
    Status?: StudentStatus;
    SubjectTypes?: string[];     // OBSOLETE - Use only for compatibility
    TagIDs?: string[];
    Telephone?: TelephoneInformationUpdateItem | null;

    constructor(initializer?: Partial<StudentUpdateItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "StudentUpdateItem";
}
